export default __webpack_public_path__ + "static/media/people_type_five_active.424e0476.svg";